


















import { Component, Prop, Vue, Emit, Watch } from 'vue-property-decorator';
import VueDatepicker from 'vuejs-datepicker';
import { ja } from 'vuejs-datepicker/dist/locale';
import moment, { Moment } from 'moment';
import { uuid } from 'vue-uuid';

@Component({
  components: {
    VueDatepicker,
  },
})
export default class YearPicker extends Vue {
  private language: object = ja;
  private id: string = '';
  private formatted: string = '';
  private tooltip: string = '';
  @Prop()
  private value!: string | null;
  @Prop({default: 'YYYY'})
  private format!: string;
  @Prop({default: null})
  private appendClass!: string | null;
  @Prop({default: false})
  private disabled!: boolean;

  private alert: boolean = false;

  public created(): void {
    this.id = uuid.v1();
    moment.locale('ja');
    this.apply();
  }

  private style(): any {
    const style: any = {
      disabled: this.disabled,
      alert: this.alert,
    };
    if (!this.appendClass) {
      return style;
    }
    if (typeof this.appendClass === 'string') {
      style[this.appendClass] = true;
      return style;
    }
    return Object.assign(style, this.appendClass);
  }

  @Watch('value')
  private apply(): void {
    this.formatted = '';

    if (!this.value) {
      return;
    }

    if (this.value.match(/^(19|20)\d{2}$/g)) {
      this.formatted = moment(this.value + '-01-01').format(this.format);
      return;
    }
    this.formatted = this.value;
  }

  private textualFormat(event: Event): void {
    if (!this.value) {
      return;
    }

    if (this.value.match(/^(19|20)\d{2}$/g)) {
      this.formatted = this.value;
      this.$nextTick(() => {
        const target = event.target as HTMLInputElement;
        target.select();
      });
      return;
    }

    this.alert = true;
    this.tooltip = '不正な年です';
    this.formatted = this.value;
    this.$nextTick(() => {
      const target = event.target as HTMLInputElement;
      target.select();
    });
  }

  @Emit('input')
  private update(event: Event): string | null {
    this.alert = false;
    this.tooltip = '';

    const target = event.target as HTMLInputElement;
    if (!target.value) {
      return null;
    }

    if (target.value.match(/^(19|20)\d{2}$/g)) {
      return target.value;
    }

    this.inValid(event);
    return target.value;
  }

  private click(): void {
    this.$modal.show(this.id);
  }

  @Emit('input')
  private select(date: Date): string | null {
    this.$modal.hide(this.id);

    if (!date) {
      return null;
    }

    return moment(date).format('YYYY');
  }

  private inValid(event: Event): void {
    this.alert = true;
    this.tooltip = '不正な年です';
    this.$nextTick(() => {
      const target = event.target as HTMLInputElement;
      target.select();
    });
  }
 }
